import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import PropTypes from 'prop-types'

import Typography from 'components/atoms/Typography'
import CustomModal from 'components/molecules/CustomModal'

function ModalDescription({ children, open, handleClose, title, subtitle }) {
  return (
    <CustomModal open={open} closeModal={handleClose} title={title}>
      <div className="lightbox__modal">
        <Typography cssClass="mb-3">{subtitle}</Typography>
        <Typography variant="span" color="gray-100" cssClass="mb-2">
          {children}
        </Typography>
      </div>
    </CustomModal>
  )
}

ModalDescription.propTypes = {
  children: PropTypes.node,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string,
}

export default ModalDescription
